import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

export const MainContainer = styled.div`
  position: relative;
  z-index: 0;
  min-height: 100vh;
  background-color: var(--color-bg-light, #fff);
  color: var(--color-fg, #333);
`

export const ContentSection = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1.5rem 3rem;
  font-family: var(--font-family-ayala-display-sans, inherit);

  ${media.lessThan('medium')`
    padding: 1.5rem 1rem 2rem;
  `}
`

export const SectionWithLeftMargin = styled.div`
  margin-left: 2rem;
`

export const PageTitle = styled.h1`
  font-family: var(--font-family-ayala-display-sans, inherit);
  font-size: 2rem;
  text-align: center;
  font-weight: 800;
  margin: 0 0 0.25rem 0;
  color: var(--color-fg, #333);
`

export const RevisionDate = styled.p`
  font-size: 1rem;
  text-align: center;
  font-style: italic;
  color: var(--color-fg, #333);
  opacity: 0.8;
  margin: 0 0 2rem 0;
`

export const SectionTitle = styled.h2`
  font-family: var(--font-family-ayala-display-sans, inherit);
  font-size: 1.25rem;
  font-weight: 700;
  margin: 2rem 0 0.75rem 0;
  color: var(--color-fg, #333);
`

export const BodyText = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 1rem 0;
  color: var(--color-fg, #333);
`

export const BoldText = styled.span`
  font-weight: 700;
  color: var(--color-fg, #333);
`

export const List = styled.ul`
  margin: 0 0 1rem 0;
  padding-left: 1.5rem;
  font-size: 1rem;
  line-height: 1.6;

  ${props =>
    props.$triangle &&
    css`
      list-style: none;
      padding-left: 1.25rem;
      li {
        position: relative;
        padding-left: 0.75rem;
        margin-bottom: 0.5rem;
        &::before {
          content: '▸';
          position: absolute;
          left: 0;
          color: inherit;
          font-size: 0.7em;
        }
      }
    `}
`

export const ListItem = styled.li`
  margin-bottom: 0.5rem;
`

export const StyledLink = styled.a`
  color: var(--color-primary, #480b69);
  text-decoration: underline;
  &:hover {
    color: var(--color-primary-hover, #5e0f85);
  }
`
